var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "knowledge-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName,
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.formData,
                    "label-width": _vm.formLabelWidth,
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "封面照",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", [_vm._v("尺寸:840*480")]),
                          _c("Upload", {
                            ref: "uploadRef",
                            attrs: {
                              accept: ".jpg,.jpeg,.png",
                              limitText:
                                "圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                              payload: _vm.formData,
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 1,
                              "use-drag": false,
                              action: "TravelSettings/saveKnowledgeArticle",
                              "auto-upload": false,
                              "show-file-list": true,
                              "btn-txt": "上傳",
                              "before-file-list":
                                _vm.formData.fileInfo &&
                                _vm.formData.fileInfo.length
                                  ? _vm.formData.fileInfo[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "國家",
                        prop: "countryCascader",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          props: {
                            multiple: true,
                            value: "id",
                          },
                          placeholder: "請選擇",
                          filterable: "",
                          options: _vm.travelAttractionsMenu,
                        },
                        model: {
                          value: _vm.formData.countryCascader,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "countryCascader", $$v)
                          },
                          expression: "formData.countryCascader",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "標題",
                        prop: "title",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formData.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "title", $$v)
                          },
                          expression: "formData.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "連結",
                        prop: "externalUrl",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formData.externalUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "externalUrl", $$v)
                          },
                          expression: "formData.externalUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "內容",
                        "label-width": _vm.formLabelWidth,
                        prop: "articleContent",
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("tinymce", {
                            ref: "tinymce",
                            attrs: { height: 300, type: 28 },
                            model: {
                              value: _vm.formData.articleContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "articleContent", $$v)
                              },
                              expression: "formData.articleContent",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "排序",
                        "label-width": _vm.formLabelWidth,
                        prop: "sort",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.formData.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sort", $$v)
                          },
                          expression: "formData.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.saveData } },
                [_vm._v("確 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.onDialogClosed()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "標題查詢" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入標題" },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "國家查詢" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      props: {
                        multiple: true,
                        value: "id",
                      },
                      placeholder: "請選擇",
                      filterable: "",
                      options: _vm.travelAttractionsMenu,
                    },
                    model: {
                      value: _vm.listQuery.countryAreaList,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "countryAreaList", $$v)
                      },
                      expression: "listQuery.countryAreaList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getSearch },
                    },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "success" }, on: { click: _vm.addData } },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "knowledge-list",
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "ID", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "封面照", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { height: "80px" },
                          attrs: {
                            src:
                              scope.row.fileInfo.length > 0
                                ? scope.row.fileInfo[0].files[0].url
                                : "https://fakeimg.pl/280x160/",
                            fit: "contain",
                            "preview-src-list": _vm.fileUrl(scope.row.fileInfo),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "國家", width: "450" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            rows: 6,
                            type: "textarea",
                            disabled: "",
                            value: _vm.showCountry(scope.row.countryCascader),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "標題", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.title))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "連結", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                scope.row.externalUrl == ""
                                  ? _vm.openUrl + "/" + scope.row.id
                                  : scope.row.externalUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { color: "rgb(64, 158, 255)" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.externalUrl == ""
                                      ? _vm.openUrl + "/" + scope.row.id
                                      : scope.row.externalUrl
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "排序",
                  sortable: "custom",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.sort))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "建立時間",
                  sortable: "custom",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.dataTime(row.buildDate))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteData(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }